import { PostId } from '../model/post.types';
import { Reply } from '../model/reply.types';
import { ReplyCell } from './ReplyCell';
import { CommentsToggle } from './CommentsToggle';
import { Collapsible } from './Collapsible';

type Props = {
  reply: Reply;
  childReplies: Reply[];
  postId: PostId;
  expanded: boolean;
  onToggle: () => void;
  onReply: (target: Reply) => void;
  mentions: string[];
};

export const ReplyThreadItem = ({
  reply,
  childReplies,
  postId,
  expanded,
  onToggle,
  onReply,
  mentions,
}: Props) => (
  <div>
    <ReplyCell
      reply={reply}
      postId={postId}
      onReply={() => onReply(reply)}
      threadToggle={
        childReplies.length > 0 ? (
          <CommentsToggle
            count={childReplies.length}
            singular="reply"
            plural="replies"
            isExpanded={expanded}
            onToggle={onToggle}
          />
        ) : undefined
      }
      mentions={mentions}
    />
    {childReplies.length > 0 && (
      <Collapsible expanded={expanded}>
        <div className="flex flex-col divide-y divide-[#EEEEEE] pl-10">
          {childReplies.map((child) => (
            <ReplyCell
              key={child.id}
              reply={child}
              postId={postId}
              onReply={() => onReply(child)}
              mentions={mentions}
            />
          ))}
        </div>
      </Collapsible>
    )}
  </div>
);
